import React from "react";

// components


export default function HeaderStats({systemSettings}) {
  const backgroundColor=systemSettings?.headerStats??" bg-qt-light"
  return (
    <>
      {/* Header */}
      <div style={{zIndex:-1,backgroundColor}} className={`relative ${backgroundColor} md:pt-24 pb-24 pt-12`}>
        <div className="px-4 md:px-10 mx-auto w-full">
        </div>
      </div>
    </>
  );
}
